import type { SVGProps } from 'react'

type Props = Omit<SVGProps<SVGSVGElement>, 'className'> & { className?: string }

const FileIcon = ({ className, ...props }: Props) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
    >
        <path
            d="M7 3.75H13.1719C13.5033 3.75008 13.8213 3.88186 14.0557 4.11621L17.8838 7.94434C18.1181 8.17869 18.2499 8.49671 18.25 8.82812V19C18.25 19.6904 17.6904 20.25 17 20.25H7C6.30964 20.25 5.75 19.6904 5.75 19V5C5.75 4.30964 6.30964 3.75 7 3.75Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13 4V7C13 8.10457 13.8954 9 15 9H18"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default FileIcon
